import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
export default class CustomStyle extends Plugin {
  init() {
    const editor = this.editor;
    const model = editor.model;
    const conversion = editor.conversion;

    // Allow 'id' attribute on heading* elements:

    // Either by extending each heading definition:
    editor.model.schema.extend("$text", {
      allowAttributes: ["id"]
    });
    editor.model.schema.extend("$block", {
      allowAttributes: ["id"]
    });
    editor.model.schema.extend("$root", {
      allowAttributes: ["id"]
    });
    editor.model.schema.extend("table", {
      allowAttributes: ["id"]
    });
    editor.model.schema.extend("image", {
      allowAttributes: ["id"]
    });
    editor.model.schema.extend("tableCell", {
      allowAttributes: ["id"]
    });
    // Then the conversion might be a two way attribute-to-attribute:
    conversion.attributeToAttribute({
      model: "id",
      view: "id"
    });
  }
}
